<template>
    <div class="grid">
        <div class="col-12">
            <div v-if="!isEdit" class="card">
                <h5>Form Detail</h5>
                <div class="formgroup-inline">
                    <div class="field">
                        <label for="dd" class="font-medium">Input Candidate Name</label>
                        <AutoComplete forceSelection placeholder="Search" id="dd" :dropdown="true" v-model="selectedAutoValue"
                            :suggestions="autoFilteredValue" @complete="searchCandidate($event)" @item-select="selectCandidate()" field="name" :disabled="isSelected"/>
                        <Button label="Remove" class="p-button-primary mr-2 ml-2" @click="clearSelected" :disabled="!isSelected"/>
                    </div>
                </div>
            </div>
            <div class="card">
                <h4>Next Detail</h4>
                <TabView v-model:activeIndex="active">
                    <TabPanel header="Candidate Information" :disabled="!isSelected">
                        <PersonalVue :model="candidate"></PersonalVue>
                        <div class="p-fluid">
                            <Button @click="active = 1" id="button1" label="Next" />
                        </div>
                    </TabPanel>
                    <TabPanel header="Setup Placement" :disabled="!isSelected">
                        <SetupPlacementVue ref="placement"></SetupPlacementVue>
                        <div class="p-fluid">
                            <Button @click="active = 2" label="Next"/>
                        </div>
                    </TabPanel>
                    <TabPanel header="Training" :disabled="!isSelected">
                        <TrainingAssessement ref="assessement"></TrainingAssessement>
                        <div class="p-fluid">
                            <Button label="Save" @click="store" :disabled="!isSelected"/>
                        </div>
                    </TabPanel>
                </TabView>
            </div>
        </div>
    </div>
</template>
<script>
import Button from "primevue/button";
import Dropdown from "primevue/dropdown";
import Calendar from "primevue/calendar";
import InputText from "primevue/inputtext";
import AutoComplete from 'primevue/autocomplete';
import TabView from "primevue/tabview";
import TabPanel from "primevue/tabpanel";
import AppLayout from '../../../Layouts/AppLayout';
import PersonalVue from "./Components/PersonalInfo";
import SetupPlacementVue from "./Components/SetupPlacement.vue";
import TrainingAssessement from "./Components/TrainingAssessement";
import axios from "axios";

export default {
    layout: AppLayout,
    components: {
        Dropdown, Calendar, InputText, AutoComplete, Button, TabView, TabPanel, PersonalVue, SetupPlacementVue, TrainingAssessement,
    },
    props: ['candidate'],
    data() {
        return {
            submitted: false,
            candidate: [],
            autoFilteredValue: [],
            selectedAutoValue: '',
            isSelected: false,
            active: 0,
            isEdit: false,
        }
    },
    computed: {

    },
    mounted() {
        if(this.$page.props.training){
            this.selectedAutoValue = this.$page.props.training.applicant;
            this.selectCandidate(this.$page.props.training.applicant_id);
            this.isEdit = true;
        }
    },
    methods: {
        searchCandidate(event) {
				setTimeout(() => {
					if (!event.query.trim().length) {
                        axios.get(`${this.$page.props.appUrl}api/applicants`)
                        .then((data)=>{
                            this.autoFilteredValue = data.data.data;
                        });
					}
					else {
                        let filterValue = event.query.toLowerCase();
                        axios.get(`${this.$page.props.appUrl}api/applicants?search=${filterValue}`)
                        .then((data)=>{
                            this.autoFilteredValue = data.data.data;
                        });
					}
				}, 250);
			},
        selectCandidate(){
            this.isSelected = true;
            axios.get(`${this.$page.props.appUrl}api/applicants/${this.selectedAutoValue.id}`)
                .then((data) => {
                    this.candidate = data.data.data;
                });
        },
        clearSelected(){
            this.selectedAutoValue = '';
            this.isSelected = false;
        },
        store(){
            let placement = this.$refs.placement.form;
            let assessement = this.$refs.assessement.assessements;
            let form_assessement = this.$refs.assessement.form;
            let new_assessement = [];
            const keys = Object.keys(assessement);

            keys.forEach((key, index) => {
                var obj = {};
                obj[assessement[index]['field_name']] = assessement[index]['score'];
                new_assessement.push(obj);
            });

            let judul = {...new_assessement};
            let payload = {applicant_id: this.candidate.id ,...placement, ...form_assessement, assessements: judul};

            if(this.isEdit){
                axios.put(`${this.$page.props.appUrl}api/applicant-trainings/${this.$page.props.training.id}`,payload)
                .then((data) => {
                    this.$toast.add({
                        severity: "success",
                        summary: "Successful",
                        detail: "Candidate Training Updated",
                        life: 3000,
                    });
                })
                .catch((error) => {
                    this.$toast.add({
                        severity: "error",
                        summary: "Error When Updating Training",
                        detail: error,
                        life: 3000,
                    });
                })
            }
            else{
                axios.post(`${this.$page.props.appUrl}api/applicant-trainings`,payload)
                .then((data) => {
                    this.$toast.add({
                        severity: "success",
                        summary: "Successful",
                        detail: "Candidate Training Created",
                        life: 3000,
                    });
                })
                .catch((error) => {
                    this.$toast.add({
                        severity: "error",
                        summary: "Error When Created Training",
                        detail: error,
                        life: 3000,
                    });
                })
            }
        },
    }
}
</script>
